<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import autofit from "autofit.js";

export default {
  name: "App",
  mounted() {
    autofit.init({
      designHeight: 1080, // 设计稿的高度，默认是 929 ，如果项目以全屏展示，则可以设置为1080
      designWidth: 1920, // 设计稿的宽度，默认是 1920
      renderDom: "#app", // 渲染的dom，默认是 "#app"，必须使用id选择器
      resize: true, // 是否监听resize事件，默认是 true
    });
  },
};
</script>

<style>
@import url(./assets/css/common.css);
html,
body {
  width: 100%;
  height: 100%;
  /* height: 10000px; */
  margin: 0;
  min-width: 1280px;
  overflow-y: scroll;
  overflow-x: hidden;
  /* min-height: 2000px; */
}
#app {
  overflow-y: scroll;
  overflow-x: hidden;
  /* overflow: hidden; */
  width: 100%;
  height: 100%;
  min-width: 1280px;
  /* min-height: 2000px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue